<template>
  <div class="modal-content border-0 shadow">
    <div class="modal-header pb-0 border-0">
      <div class="col-12">
        <button
          type="button"
          class="btn btn-block d-flex ms-auto"
          style="left: 0; top: 0"
          @click="close"
        >
          <v-icon
            icon="times"
            width="20"
            height="20"
          />
        </button>
      </div>
    </div>
    <div class="modal-body pb-5">
      <div class="col-12 col-md-9 mx-auto">
        <div class="d-flex mx-auto">
          <img
            :src="`${aws}/unicorn-feather.png`"
            class="mx-auto mb-3"
          >
        </div>
        <h5 class="text-center">
          Vous êtes en train d'ajouter une option...
        </h5>
        <p class="text-center">
          Vous pouver valider l'option ou continuer à enrichir votre
          contrat pour être encore plus couvert en cas de problème
        </p>
        <div class="d-flex flex-column">
          <v-loader
            :next="() => $router.push(`/client/contracts/${contract.id}/summary`)"
            title="Valider mon option"
            icon="arrow-white-right"
            class="mb-1"
          />
          <v-loader
            :next="() => $router.push(`/client/contracts/${contractRouteId}`)"
            color="blue-300"
            icon="plus"
            title="Ajouter d'autres options"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';
import { getContractRouteId } from '@/utils/contractRoute';

export default {
  mixins: [ui],
  computed: {
    ...mapGetters({
      contract: 'contract/get',
      cancelAction: 'ui/crossSellCancelAction',
    }),
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    contractRouteId() {
      return getContractRouteId(this.contract);
    },
  },
  methods: {
    async close() {
      await this.cancelAction();
      this.ui_showModalCrossSell({ value: false, type: null, cancel: () => {} });
    },
  },
};
</script>
